import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Upload as AntUpload } from 'antd';
import Attachment from 'pages/Organization/Documents/Attachment';
import { getBase64 } from 'utils/helpers';
import { UPLOAD_STATUS } from 'constants/constants';
import { pathOr } from 'ramda';
import UploadButton from './UploadButton';
import { beforeUpload, beforeUploadDocuments, TYPES } from './helpers';
var Upload = function (_a) {
    var _b = _a.attach, attach = _b === void 0 ? function () { } : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.value, value = _d === void 0 ? {} : _d, _e = _a.image_url, image_url = _e === void 0 ? '' : _e, _f = _a.onChange, onChange = _f === void 0 ? function () { } : _f, _g = _a.type, type = _g === void 0 ? '' : _g;
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var localUrl = pathOr(null, ['localUrl'], value);
    var valueUrl = pathOr(null, ['image_url'], value);
    var image = pathOr(null, ['image'], value);
    var uploadFile = type === 'document' ? TYPES.document : TYPES.image;
    var contentType = pathOr('', ['type'], image);
    var url = localUrl || valueUrl;
    var handleChange = function (info) {
        var file = info.file;
        var originFile = file.originFileObj;
        getBase64(originFile, function (localUrl) {
            onChange({
                image_url: image_url,
                image: originFile,
                localUrl: localUrl
            });
            if (attach)
                attach(originFile);
            if (file.status === UPLOAD_STATUS.uploading)
                setLoading(true);
            else
                setLoading(false);
        });
    };
    return (_jsx(AntUpload, { showUploadList: false, listType: "picture-card", className: "avatar-uploader", customRequest: function () { }, accept: uploadFile.accept, beforeUpload: function (file) {
            return type === 'document' ? beforeUploadDocuments(file) : beforeUpload(file);
        }, onChange: handleChange, disabled: disabled, "data-test": "uploadBtn", children: url ? (_jsx(Attachment, { contentType: contentType, fileUrl: url, onClick: function () { } })) : (_jsx(UploadButton, { loading: loading })) }));
};
export default Upload;
